import { render, staticRenderFns } from "./PreviewHeader.vue?vue&type=template&id=b3b02036"
import script from "./PreviewHeader.vue?vue&type=script&lang=ts"
export * from "./PreviewHeader.vue?vue&type=script&lang=ts"
import style0 from "./PreviewHeader.vue?vue&type=style&index=0&id=b3b02036&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports